<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Squirrel Umgebung ändern</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="squirrelEnvironmentForm" novalidate>

            <mat-form-field style="width: 0; height: 0;">
                <input matInput hidden  formControlName="id" readonly>
            </mat-form-field>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="example-full-widtht">
                        <input matInput formControlName="name">
                    </mat-form-field>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="url">
                    </mat-form-field>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="numberOfMigrations" readonly>
                    </mat-form-field>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="migratedWhen" readonly>
                    </mat-form-field>
                </div>
            </div>      -->

            <!-- <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="update()" color="primary">Squirrel Environment</button> -->
        </form>
        <div class="row">
            <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Dialog schließen"
                            (click)="cancel()" >Abbruch</button>
            </a>                                                
            <span style="flex: 1 1 auto"></span>
            <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Umgebung ändern"
                                    (click)="update()" >Ändern</button>
            </a>                   
        </div>

    </div>
</div>